export function initAnalytics() {
  const id = process.env.REACT_APP_GA_ID;
  if (!id || window.gtag) return;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  window.gtag("config", id);
}

export function track(eventName, params = {}) {
  if (window.gtag) window.gtag("event", eventName, params);
}

export const trackPlanVisitClick = () => track("plan_visit_click");
export const trackPlanVisitSubmit = () => track("plan_visit_submit");
export const trackService1Submit = () => track("service1_registration");
export const trackDirectionsClick = () => track("get_directions_click");
export const trackPhoneClick = () => track("phone_click");
export const trackEmailClick = () => track("email_click");
export const trackSermonPlay = (title) => track("sermon_play", { sermon: title });
export const trackEventRegistration = (title) => track("event_registration", { event: title });
export const trackGiveClick = () => track("give_click");
